import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector} from 'react-redux';
import { FiEdit, FiDelete } from 'react-icons/fi';
import {Link} from 'react-router-dom';
import { deleteABlog, getBlogs, resetState } from '../features/blogs/blogSlice';
import CustomModal from '../components/CustomModal';

const columns = [
  {
    title: 'No',
    dataIndex: 'key',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    defaultSortOrder: 'descend',
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: 'Category',
    dataIndex: 'category',
  },
  {
    title: 'Action',
    dataIndex: 'action',
  },
];


const Bloglist = () => {
  const [open, setOpen] = useState(false);
  const [blogId, setblogId] = useState('');
  const showModal = (e) => {
    setOpen(true);
    setblogId(e);
  };
  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getBlogs());
  }, []);
  const getBlogState = useSelector((state) => state.blogs.blogs);
  const data1 = [];
  for (let i = 0; i < getBlogState.length; i++) {
    data1.push({
      key: i + 1,
      name: getBlogState[i].title,
      category: getBlogState[i].category,
      action: <><Link to={`/admin/blog/${getBlogState[i]._id}`}><FiEdit /></Link><button onClick={() => showModal(getBlogState[i]._id)} className='ms-3 text-danger bg-transparent border-0'><FiDelete /></button></>,
    });
  }
  const deleteBlog = (e) => {
    setOpen(false);
    dispatch(deleteABlog(e));
    setTimeout(() => {
      dispatch(getBlogs());
    },100);
  };
  return (
    <div>
      <h3 className='mb-4'>Blogs</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal hideModal={hideModal} open={open} title='Are you sure to delete it?' action={() => {deleteBlog(blogId)}} />
    </div>
  )
}

export default Bloglist
